module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Katherine Garbera\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Katherine Garbera is a "), _c('I', [_vm._v("USA TODAY")]), _vm._v(" bestselling author of more than 100 novels, which have been translated into over two dozen languages and sold millions of copies worldwide. She is the mother of two incredibly creative and snarky grown children, Katherine enjoys champagne, reading, walking and traveling with her husband. Visit her on the web at "), _c('a', {
    attrs: {
      "href": "http://www.katherinegarbera.com"
    }
  }, [_vm._v("www.katherinegarbera.com")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/163EE3w/tc-custom/9781460325643.jpg?1721404702144",
      "alt": "This image is the cover for the book Bound by a Child, Baby Business"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bound by a Child, Baby Business\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In USA TODAY bestselling author Katherine Garbera's Baby Business trilogy, two polar opposites unite for the sake of a baby "), _c('br'), _c('br'), _vm._v("Cocky businessman Allan McKinney has always gotten on Jessi Chandler's nervesespecially now that he's taking over her family's company. But when tragedy strikes, and they become coguardians of their best friends' child, Allan shows Jessi his sensitive side, going from unbearable to irresistible just like that. "), _c('br'), _c('br'), _vm._v("For Allan, it's getting harder to keep his eye on the bottom line when his head is turned by Jessi. Now a storm is brewing that threatens to blow away their fragile bond. Will Allan and Jessi let their very personal merger slip through their fingers?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0